import {Close} from '@mui/icons-material'
import {Grid, Modal, Box, IconButton, Skeleton} from '@mui/material'
import React, {useEffect, useState} from 'react'
import WbTextField from '../../../components/common/WbTextField'
import EmojiPicker, {Emoji} from 'emoji-picker-react'
import WbButton from '../../../components/common/WbButton'
import WbOutlineButton from '../../../components/common/WbOutlineButton'
import questionsApi from '../../../services/api/questionLibrary/questionsApi'
import WbLoader from '../../../components/common/WbLoader'

export default function ChangeQuestion({onClose, question, setQuestion}) {
  const [showEmojiPicker, setShowEmojiPicker] = React.useState(false)
  const [index, setIndex] = React.useState(0)
  const [checkInQuestion, setCheckInQuestion] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    questionsApi
      .getListByIds([question.id])
      .then(res => {
        setCheckInQuestion({
          ...res[0],
          multiOptionResponseAttributes: [
            ...res[0].multiOptionResponseAttributes,
          ],
        })
      })
      .finally(e => {
        setLoading(false)
      })
  }, [])
  if (loading)
    return (
      <Modal
        open={true}
        onClose={() => {
          onClose()
        }}
        style={{
          background: 'transparent',
          backdropFilter: 'blur(5px)',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />            
              </>
            </Grid>
          </Grid>
        </Box>
        
      </Modal>
    )

  return (
    <Modal
      open={true}
      onClose={() => {
        onClose()
      }}
      style={{
        background: 'transparent',
        backdropFilter: 'blur(5px)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Modal
          open={showEmojiPicker}
          onClose={() => {
            setShowEmojiPicker(false)
          }}
          style={{
            background: 'transparent',
            backdropFilter: 'blur(5px)',
          }}
        >
          <EmojiPicker
            skinTonesDisabled
            style={{
              zIndex: 9999,
              top: '10%',
              left: '40%',
            }}
            onEmojiClick={e => {
              const newOptions = [
                ...checkInQuestion?.multiOptionResponseAttributes,
              ]
              newOptions[index].pupilEmoji = e.unified
              setCheckInQuestion({
                ...checkInQuestion,
                multiOptionResponseAttributes: [...newOptions],
              })
              setShowEmojiPicker(false)
            }}
            emojiStyle={{width: '100%', height: '100%'}}
            size={24}
          />
        </Modal>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <h2>Change Check In Question</h2>
          </Grid>
          <Grid item xs={6}>
            <IconButton onClick={onClose} sx={{float: 'right'}}>
              <Close sx={{color: '#000'}} />
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <div className="info-panel">
              You can change the check in question here. The question will be
              used in all check ins.
            </div>
          </Grid>
          <Grid item xs={12}>
            <WbTextField
              label={'Check In Question'}
              fullWidth
              value={checkInQuestion?.pupilText}
              onChange={e => {
                setCheckInQuestion({
                  ...checkInQuestion,
                  pupilText: e.target.value,
                })
              }}
            />
          </Grid>
          {checkInQuestion?.multiOptionResponseAttributes?.map(
            (option, idx) => (
              <>
                <Grid item xs={8}>
                  <WbTextField
                    key={idx}
                    label={`Answer Option ${idx + 1}`}
                    fullWidth
                    value={option.pupilText}
                    onChange={e => {
                      const newOptions = [
                        ...checkInQuestion?.multiOptionResponseAttributes,
                      ]
                      newOptions[idx].pupilText = e.target.value
                      setCheckInQuestion({
                        ...checkInQuestion,
                        multiOptionResponseAttributes: [...newOptions],
                      })
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <WbTextField
                    label={'Num Value'}
                    type="number"
                    fullWidth
                    value={option.numValue}
                    onChange={e => {
                      const newOptions = [
                        ...checkInQuestion?.multiOptionResponseAttributes,
                      ]
                      newOptions[idx].numValue = e.target.value
                      setCheckInQuestion({
                        ...checkInQuestion,
                        multiOptionResponseAttributes: [...newOptions],
                      })
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  onClick={e => {
                    setShowEmojiPicker(!showEmojiPicker)
                    setIndex(idx)
                  }}
                >
                  <Emoji unified={option?.pupilEmoji} />
                </Grid>
              </>
            )
          )}

          <Grid item xs={6}>
            <WbOutlineButton
              CustomOutlineButtonText={'Cancel'}
              onClick={w => onClose()}
            />
          </Grid>
          <Grid item xs={6} sx={{textAlign: 'right'}}>
            <WbButton
              CustomButtonText={'Save'}
              onClick={w => {
                questionsApi
                  .post({
                    ...checkInQuestion,
                    multiOptionResponseAttributes: [
                      ...checkInQuestion.multiOptionResponseAttributes,
                    ],
                  })
                  .then(res => {
                    setQuestion({
                      ...res,
                      multiOptionResponseAttributes: [
                        ...res.multiOptionResponseAttributes,
                      ],
                    })
                    onClose()
                  })
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
